<template>
  <section style="padding:20px;">
    <section style="display: flex;justify-content: flex-start; align-items: center;">
        <el-page-header @back="goBack" content="网关日志"> </el-page-header>
        <div style="width:40px"></div>
        <!-- <el-button type="primary" @click="download">导出</el-button> -->
    </section>
    
    <section style="padding-top:20px;">
      <el-table
        ref="table"
        border
        :data="logs"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-if="logs.length > 0"
        v-loading="tableLoading"
      >
        <el-table-column label="网关编号" prop="gatewaySn"></el-table-column>
        <el-table-column label="请求内容" prop="responseCommand">
        </el-table-column>
        <el-table-column
          label="响应内容"
          prop="reportStatusCommand"
        ></el-table-column>
        <el-table-column label="创建时间" prop="crtTime"> </el-table-column>
      </el-table>
      <div
        v-else
        style="
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <el-empty description="暂无数据"></el-empty>
      </div>
    </section>
    <Page v-on:pagination="receivePaginationData"></Page>
  </section>
</template>
<script>
import { gatewayLog } from "@/api/url";
import { mapMutations, mapState } from "vuex";
import Page from "@/page/commons/page";
export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      gatewaySn: this.$route.query?.gatewaySn ?? "",
      logs: [],
      tableLoading: false,
      search: {
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
  },
  mounted() {
    this.getlogs();
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.getlogs();
    },
    goBack() {
      this.$router.go(-1);
    },
    getlogs() {
        this.tableLoading = true;
      this.$postRequest(gatewayLog(), {
        gatewaySn: this.gatewaySn,
        page: this.search.pageNumber,
        limit: this.search.pageSize,
      }).then((res) => {
        if (res?.status == 200) {
          var pageObj = {
            curIndex: res.data.offset,
            rowsCount: res.data.total,
          };
          this.getPage(pageObj);
          this.logs = res?.data?.rows ?? [];
        }
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    download(){

    }
  },
};
</script>
<style scoped></style>
